"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: 1000,
  timeout: 30000,
  retryableErrors: ['Failed to fetch', 'NetworkError', 'TypeError', 'AbortError'],
  retryableStatusCodes: [408, 429, 500, 502, 503, 504]
};
var httpRequest = (applicationToken, sessionToken) => {
  function RequestHeaderBuilder() {
    var DEFAULT_REQUEST_HEADER = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'application-token': applicationToken,
      'session-token': sessionToken
    };
    function decorate() {
      var customRequestHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread(_objectSpread({}, DEFAULT_REQUEST_HEADER), customRequestHeader);
    }
    return {
      buildHeader(headers) {
        return decorate(headers);
      }
    };
  }
  function RequestBuilder() {
    var {
      REACT_APP_FUSION_ORIGIN
    } = process.env;
    function normalizePath(path) {
      if (path.startsWith('/')) {
        return path.slice(1);
      }
      return path;
    }
    function buildUrl(path) {
      return "".concat(REACT_APP_FUSION_ORIGIN, "/").concat(normalizePath(path));
    }
    function buildBody(payload) {
      if (!payload) {
        return {};
      }
      return {
        body: JSON.stringify(payload)
      };
    }
    function isRetryableError(error) {
      if (!error) return false;
      if (error.name === 'AbortError') return true;
      if (error.status && RETRY_CONFIG.retryableStatusCodes.includes(error.status)) return true;
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) return true;
      if (error.name === 'NetworkError') return true;
      if (error.message) {
        return RETRY_CONFIG.retryableErrors.some(retryableError => error.message.includes(retryableError));
      }
      return false;
    }
    function delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    function fetchWithRetry(_x, _x2) {
      return _fetchWithRetry.apply(this, arguments);
    }
    function _fetchWithRetry() {
      _fetchWithRetry = _asyncToGenerator(function* (url, options) {
        var retryCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var abortController = new AbortController();
        var timeoutId = setTimeout(() => {
          abortController.abort();
        }, RETRY_CONFIG.timeout);
        try {
          var fetchOptions = _objectSpread(_objectSpread({}, options), {}, {
            signal: abortController.signal
          });
          var response = yield fetch(url, fetchOptions);
          clearTimeout(timeoutId);
          if (!response.ok && RETRY_CONFIG.retryableStatusCodes.includes(response.status)) {
            var error = new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
            error.status = response.status;
            throw error;
          }
          return response;
        } catch (error) {
          clearTimeout(timeoutId);
          if (error.name === 'AbortError') {
            error.message = "Request timeout after ".concat(RETRY_CONFIG.timeout, "ms");
          }
          if (retryCount < RETRY_CONFIG.maxRetries && isRetryableError(error)) {
            var delayMs = RETRY_CONFIG.retryDelay * Math.pow(2, retryCount);
            console.warn("HTTP Request failed, retrying in ".concat(delayMs, "ms (attempt ").concat(retryCount + 1, "/").concat(RETRY_CONFIG.maxRetries, "):"), error.message);
            yield delay(delayMs);
            return fetchWithRetry(url, options, retryCount + 1);
          }
          console.error('HTTP Request failed:', error);
          throw error;
        }
      });
      return _fetchWithRetry.apply(this, arguments);
    }
    function build(path, method, payload, headers) {
      var options = {
        method,
        headers,
        mode: 'cors'
      };
      if (method !== 'GET') {
        options = _objectSpread(_objectSpread({}, options), buildBody(payload));
      }
      return fetchWithRetry(buildUrl(path), options);
    }
    return {
      get(path, payload, headers) {
        return build(path, 'GET', payload, headers);
      },
      post(path, payload, headers) {
        return build(path, 'POST', payload, headers);
      },
      patch(path, payload, headers) {
        return build(path, 'PATCH', payload, headers);
      },
      deleteMethod(path, payload, headers) {
        return build(path, 'DELETE', payload, headers);
      }
    };
  }
  return _objectSpread(_objectSpread({}, RequestHeaderBuilder()), RequestBuilder());
};
var _default = exports.default = httpRequest;